import { randomArray } from '@library/common/functions';

import { MockPath, MockPagination } from '@library/common/http/mock-path.mock';

import { MockReport, MockReportList, MockReportColumn } from './report.mock';
import { MockReportResponse } from './report/report-response.mock';

export const ReportsRoutes: MockPath<unknown>[] = [
   { path: 'report/manager/.*', verb: 'GET', collection: () => [ new MockReport() ] },
   { path: 'report/manager', verb: 'GET', collection: () => randomArray( MockReportList ) },
   { path: 'enum/report_columns', verb: 'GET', collection: () => randomArray( MockReportColumn ) },
   { path: 'shipment/report', verb: 'POST', response: opts => ({
      ...new MockReportResponse( opts.body?.schema ),
      pagination: MockPagination( opts.body?.pagination ),
   })},
];
